export const getEndpoints = environment => {
  switch (environment) {
    case 'PRODUCTION':
      return {
        MULTIPLEXER_URL: 'https://sessions.datacamp.com'
      };
    case 'LOCAL':
    case 'TEST':
    case 'DEVELOPMENT':
      return {
        MULTIPLEXER_URL: 'https://sessions.datacamp-staging.com'
      };
    default:
      return {
        MULTIPLEXER_URL: 'https://sessions.datacamp-staging.com'
      };
  }
};